module.exports = __webpack_public_path__ + "static/media/sz.45988f7e.svg";